export enum SmartBuildQuestion {
  BuildingZIP = 'BuildingZIP',
  CeilingHeight = 'CeilingHeight',
  CeilingProductSystem = 'CeilingProductSystem',
  CompanyName = 'CompanyName',
  Contact = 'Contact',
  DeliveryAddress = 'DeliveryAddress',
  Email = 'Email',
  FasciaMaterial = 'FasciaMaterial',
  GablePostMaterial = 'GablePostMaterial',
  GableStudPlacement = 'GableStudPlacement',
  GableStudSpacing = 'GableStudSpacing',
  GableSubFasciaMaterial = 'GableSubFasciaMaterial',
  HasCeiling = 'HasCeiling',
  HasWainscot = 'HasWainscot',
  InteriorWainscotProductSystem = 'InteriorWainscotProductSystem',
  LeftGablePostMaterial = 'LeftGablePostMaterial',
  LeftPostMaterial = 'LeftPostMaterial',
  Length = 'Length',
  ModelerComments = 'ModelerComments',
  Offset = 'Offset',
  OpenPostMaterial = 'OpenPostMaterial',
  OverhangB = 'OverhangB',
  OverhangF = 'OverhangF',
  OverhangL = 'OverhangL',
  OverhangProductSystem = 'OverhangProductSystem',
  OverhangR = 'OverhangR',
  Overhangs = 'Overhangs',
  Phone = 'Phone',
  PostMaterial = 'PostMaterial',
  ProjectName = 'ProjectName',
  RightGablePostMaterial = 'RightGablePostMaterial',
  RightPostMaterial = 'RightPostMaterial',
  RoofColor = 'RoofColor',
  RoofFramingStyle = 'RoofFramingStyle',
  RoofMaterial = 'RoofMaterial',
  RoofProductSystem = 'RoofProductSystem',
  RoofStyle = 'RoofStyle',
  ShedPostPlacement = 'ShedPostPlacement',
  ShedPostSpacing = 'ShedPostSpacing',
  Slope2 = 'Slope2',
  Slope = 'Slope',
  StudPlacement = 'StudPlacement',
  StudSpacing = 'StudSpacing',
  SubFasciaMaterial = 'SubFasciaMaterial',
  TrimColor = 'TrimColor',
  TrussSpacing = 'TrussSpacing',
  UpperWallProductSystem = 'UpperWallProductSystem',
  WainscotColor = 'WainscotColor',
  WainscotHeight = 'WainscotHeight',
  WainscotMaterial = 'WainscotMaterial',
  WainscotProductSystem = 'WainscotProductSystem',
  WallColor = 'WallColor',
  WallLinerProductSystem = 'WallLinerProductSystem',
  WallMaterial = 'WallMaterial',
  WallProductSystem = 'WallProductSystem',
  Width = 'Width',
}
